import React from "react";
import {
  loadConfigs,
  redirectTo,
  EventBus,
  getCurrentHash,
  formatConfig,
  getCurrentAppNames,
} from "@alife/spa-helper";
import ReactDOM from "react-dom";
import Dialog from "@alife/next/lib/dialog";
import Button from "@alife/next/lib/button";
import Utils from "@alife/im-alitalk-util";
import LandingPage from "./landing-page";
import classNames from "classnames";
import PWAInstall from "./pwa-install";
import utils from "./utils";
import { performanceLog } from "./log";

const { createI18N } = window.IcbuIM.lib.I18N;

const I18N = createI18N({
  namespace: "messenger.pwa",
});

import "./index.scss";

/* ========= weblite尺寸设置========== */
// weblite 外容器 770*578
// list: 294  chat: 476
const LIST_HEIGHT_MAP = {
  expand: 578,
  fold: 50,
  "expand-notificaton": 578 + 100, // 100是浮窗高度
  "fold-notification": 50 + 100,
};

const LIST_WIDTH_MAP = {
  expand: 294,
  fold: 210,
  "expand-notificaton": 294,
  "fold-notification": 210,
};

const CHAT_EXPAND_WIDTH = 770;
const CHAT_EXPAND_HEIGHT = 578;

/**
 * 核心逻辑：
 * 1. weblite初始化
 * 2. 挂载微前端子应用: im-weblite-list/im-weblite-chat
 * 3. 通过postMessage中的type类型进行state数据更新（联系人分配&选中、打开询盘表单等）
 */
class Weblite extends React.Component {
  constructor(props) {
    super(props);
    this.listStatus = "fold"; // 会话列表当前状态
    this.chatStatus = "closechat"; // 会话窗口当前状态
    this.assignLoginIdEncrypt = ""; // 联系人重新分配后的加密loginId
    this.state = {
      webliteConfig: {},
    };
  }
  componentDidMount() {
    /* ============ 记录全局打点所需参数：host/pageId============ */
    window.host = "weblite";
    const urlParams = utils.getUrlVars(window.location.search);
    window.pageId = urlParams ? urlParams.pageId : "";

    /* =========== 初始化 ================= */
    this.microAppDidMount(); // 挂载微应用配置
    this.loadInitialMicroApp(["list"]); // 加载首屏所需微应用
    this.notifyIframe(); // 通知iframe设置正确的初始尺寸
    this.heartbeat(); // 登录态监测

    /* ===========全局事件监听============= */
    // 监听关闭chat窗口
    EventBus.on("im-weblite-chat:closeChat", () => {
      this.resizeChat("closechat");
    });

    // 监听最大化chat窗口
    EventBus.on("im-weblite-chat:maximizeChat", () => {
      this.resizeChat("maxchat");
    });

    // 联系人列表展开/收起
    EventBus.on("im-weblite-list:changeListStatus", (data) => {
      this.resizeList(data.status);
    });

    // 发送完消息
    EventBus.on("im-weblite-chat:sendMessage", (data) => {
      const { webliteConfig = {} } = this.state;
      const { activeLoginIdEncrypt = "", sceneType = "" } = webliteConfig;
      let userId = data.userInfo && data.userInfo.toLoginIdEncrypt;

      const hasSceneType =
        userId === activeLoginIdEncrypt || userId === this.assignLoginIdEncrypt;
      Utils.logMsg({
        toId: data.userInfo && data.userInfo.toLoginId,
        productId: data.userInfo && data.userInfo.productId,
        opId: data.opId,
        sceneType: hasSceneType ? sceneType : "",
      });
      if (data.marketData) {
        Utils.logMarket(data.userInfo, data.marketData);
      }
    });

    EventBus.on("weblite:notLogin", () => {
      window.parent.postMessage(JSON.stringify({ type: "LOGIN" }), "*");
    });

    EventBus.on("im-weblite-list:selectedItem", () => {
      if (this.props.isPWA) {
        this._landing.classList.add("landing-page-miss");
        this._chat.classList.add("icbu-weblite-chat-show");
      }
    });

    // 控制当前iframe尺寸
    EventBus.on("weblite:windowResize", (data) => {
      this.handleWindowResize(data);
    });

    EventBus.on("im-weblite-chat:meetingChange", (data) => {
      // 针对9510(入会后广播所有端已入会), 忽略处理
      if (data.ignore) {
        return;
      }
      // TODO: 这里有bug, 挂断视频的时候导致weblite宽度被拉伸, 但高度没有撑开; 通过强制选中人会导致其他bug
      let width, height, showType;
      showType = data.type;
      if (data.type === "show") {
        width = "100vw";
        height = "100vh";
        this.meetingShow = true;
      } else {
        width = LIST_WIDTH_MAP["fold"];
        height = LIST_HEIGHT_MAP["fold"];
        this.meetingShow = false;
        this._list.setAttribute("style", `width:${LIST_WIDTH_MAP["fold"]}px`);
        EventBus.publish("im-weblite-list:toggleList", { show: false });
      }
      window.parent.postMessage(
        JSON.stringify({ type: "meetingChange", width, height, showType }),
        "*"
      );
    });

    EventBus.on("im-weblite-list:meetingPush", (data) => {
      // 选中某个人
      EventBus.publish("im-weblite-list:selectContact", {
        activeLoginIdEncrypt: data.contactLoginIdEncrypt,
      });
      // 记一次后面清空
      this.listMeetingPush = data;
    });

    // 监听alitalk过来的事件通知
    window.addEventListener(
      "message",
      (event) => {
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (e) {}

        if (!data) return false;

        if (data.type === "nav2InquirySuc") {
          // 展示询盘成功页, 接收/msgsend/contact.htm的消息
          return this.showInquirySucceed(data.url);
        }

        if (!/^weblite:/g.test(data.type)) return false;

        const { pageId = "", scene = {}, webliteConfig = {} } = data;

        // 校正aplus脚本打点要取的pageid
        if (pageId) {
          window.pageId = window.dmtrack_pageid = pageId;
        }

        // 沟通场景入口统一参数，20210610 by 250088 https://yuque.antfin.com/docs/share/ecd9892a-1432-4e73-8bd1-88c8d0aacc7b?# 《聊天页传参规范》
        // 在data.scene对象中, 主要有fromPage/bizType/bucket 
        // 兼容未升级的alitalk组件场景参数
        if (!scene.fromPage) {
          scene.fromPage = webliteConfig.sceneType || "";
        }

        // weblite:init 初始化调用，可以用来统计调用pv、uv
        let log_msg_rev = `weblite_post_message_received&type=${data.type}`;
        if (data.type === "weblite:init") {
          // 处理场景入口参数
          let sceneParams = utils.JSONParam(scene || {});
          const sceneParamsLog = sceneParams ? `&${sceneParams}` : "";
          log_msg_rev += sceneParamsLog;
          utils.goldlog(`weblite_mounted${sceneParamsLog}`);
          performanceLog(`visit&site=weblite${sceneParamsLog}`);
        }

        // 接收到postMessage
        utils.goldlog(log_msg_rev);

        // Utils打点使用的一些参数
        if (!Utils.pageId && !Utils.refer) {
          Utils.pageId = data.pageId;
          Utils.refer = data.refer;
        }

        // 唤起和某个人的聊天窗
        if (/^weblite:(selectContact|market)/g.test(data.type)) {
          // 触发选中联系人时才设置window下的入口参数
          window["chat_entry_scene"] = scene || {};

          const { attrs = {} } = webliteConfig;

          //在weblite中打开询盘主表单，msgsend/contact.htm
          if (attrs.inquiryUrl) {
            this.showInquiryForm(attrs.inquiryUrl);
            attrs.action = "chatForInquiry"; // 询盘进沟通
          }

          // 联系人分配
          this.contactAutoAssign(webliteConfig).then((ret) => {
            if (ret.code * 1 === 200) {
              // 使用新的联系人ID
              this.assignLoginIdEncrypt = ret.data.receiverLoginIdEncrypt;
              this.selectContact(this.assignLoginIdEncrypt);
            } else {
              // 降级
              this.selectContact();
            }
          });
        }

        // 调用xman登录窗完成登录
        if (
          data.type === "weblite:reload" ||
          (data.type === "weblite:selectContact" && !isLogin())
        ) {
          EventBus.publish("im-weblite:loginSuccess");
        }

        // 更新weblite参数
        this.setState({
          webliteConfig: {
            ...data.webliteConfig,
            pageId: Utils.pageId,
          },
        });
      },
      false
    );
  }

  /**
   * 挂载weblite子应用
   * @param {*} data
   */
  microAppDidMount = () => {
    /* =============子应用配置=================== */
    let MODULES = window["SPA_MODULES"];
    let appConfigs = {};

    // 兼容微应用配置老逻辑
    if (window.webliteMicroConfig) {
      MODULES = window.SPA_MODULES = {
        list: "list",
        chat: "chat",
      };
      appConfigs = formatConfig(window.webliteMicroConfig, [
        MODULES.list,
        MODULES.chat,
      ]);
    } else {
      appConfigs = window["SPA_MODULES_CONFIG"];
    }

    // 加载子应用
    loadConfigs(
      appConfigs.map((node) => {
        if (node.appName === MODULES.chat) {
          node.customProps = {
            EventBus,
            redirectTo,
            getCurrentHash,
            getCurrentAppNames,
            boxWidth: 476,
            boxHeight: 578,
            toolbar: ["emotion", "image", "attachment"],
            host: "weblite",
            selector: "#icbu-weblite-chat",
          };
          if (this.props.isPWA) {
            node.customProps.boxWidth = "100%";
            node.customProps.boxHeight = "100%";
            node.customProps.host = "pwa";
          }
        } else if (node.appName === MODULES.list) {
          node.customProps = {
            EventBus,
            redirectTo,
            getCurrentHash,
            getCurrentAppNames,
            host: "weblite",
            selector: "#icbu-weblite-list",
          };
        }
        // node.customProps.pageId = pageId;
        return node;
      })
    );
  };

  /**
   * 加载初始化需要的子应用
   * @param {*} list  ['chat','list']
   */
  loadInitialMicroApp = (list = []) => {
    let MODULES = window["SPA_MODULES"];
    const { webliteConfig = {} } = this.state;
    const { params = {} } = webliteConfig;

    // 判断是否为PWA应用
    params.isPWA = isPWA();

    list.forEach((v) => {
      const appName = MODULES[v];
      // 加载目标应用js文件
      redirectTo({
        appName: appName,
        hash: appName,
        params: {
          ...params,
          ...params.attrs, // params.attrs中可能有额外的字段需要传递给子应用, 这里将这些额外字段提升一层，与执行EventBus.publish时传递的参数格式相对应
        },
      });
    });
  };

  /**
   * 联系人重新分配逻辑
   * @param {*} webliteConfig
   */
  contactAutoAssign = (webliteConfig = {}) => {
    if (!webliteConfig.attrs) {
      return new Promise((resolve) => {
        resolve({});
      });
    }
    return new Promise((resolve, reject) => {
      const params = JSON.stringify({
        contactLoginIdEncrypt: webliteConfig.activeLoginIdEncrypt,
        bizType: webliteConfig.attrs.bizType,
        bizId: webliteConfig.attrs.bizId,
      });
      fetch("https://onetalk.alibaba.com/csrf/getToken.htm", {
        cache: "no-cache",
        method: "POST",
        mode: "cors",
        headers: {
          "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        credentials: "include",
      })
        .then((res) => {
          return res.json();
        })
        .then((ret) => {
          return this.fetchAssignedContact(params, ret.token, resolve, reject);
        })
        .catch(() => {
          this.fetchAssignedContact(params, "", resolve, reject);
        });
    });
  };

  /**
   * 调用接口，查询重新分配的联系人ID
   * @param {*} params
   * @param {*} token
   * @param {*} resolve
   * @param {*} reject
   */
  fetchAssignedContact = (params, token, resolve, reject) => {
    const url = "https://onetalk.alibaba.com/message/distributeChat.htm";
    return fetch(url, {
      cache: "no-cache",
      method: "POST",
      mode: "cors",
      headers: {
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      credentials: "include",
      body: serialize({
        params,
        _csrf: token,
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  };

  /**
   * 改变chat窗口尺寸
   * @param {*} status closechat/maxchat
   */
  resizeChat = (status = "closechat") => {
    if (status === "maxchat") {
      if (this.listMeetingPush) {
        // 唤起chat的音视频
        const info = Object.assign({}, this.listMeetingPush);
        EventBus.publish("im-weblite-chat:meetingPush", info);
        this.listMeetingPush = null;
      }
    }

    if (this.chatStatus !== status) {
      // 通知alitalk改变iframe尺寸
      this.chatStatus = status;
      this.notifyIframe();
    }
  };

  /**
   * 改变list窗口尺寸
   * @param {*} status fold/expand
   */
  resizeList = (status = "fold") => {
    const { webliteConfig = {} } = this.state;

    if (this.listStatus !== status) {
      // list收起的时候将chat关闭
      let listWidth = LIST_WIDTH_MAP["expand"];
      if (status === "fold") {
        this.resizeChat("closechat");
        listWidth = LIST_WIDTH_MAP[isPWA() ? "expand" : "fold"];
      } else {
        this._list.classList.add("icbu-weblite-list-expand");
      }
      this._list.setAttribute("style", `width:${listWidth}px`);
      // 通知alitalk改变iframe尺寸
      this.listStatus = status;
      this.notifyIframe();
    }

    // 埋点
    const log_key = status === "expand" ? "openatm" : "webclick";
    const log_params = {
      fromuid: "enaliint" + Utils.getLoginId(),
      from: 1,
      time: +new Date(),
      version: "new",
      id: webliteConfig.productId,
      refer: Utils.refer.replace(/&/gi, "$"),
    };
    Utils.dmtrackLog(log_key, log_params);
  };

  // weblite窗体尺寸调整
  handleWindowResize = (data) => {
    let width, height, showType;
    showType = data.type;
    if (data.type === "show") {
      width = "100vw";
      height = "100vh";
    } else {
      width = CHAT_EXPAND_WIDTH;
      height = CHAT_EXPAND_HEIGHT;
    }
    window.parent.postMessage(
      JSON.stringify({ type: "meetingChange", width, height, showType }),
      "*"
    );
  };

  // 保持登录态session
  heartbeat() {
    let relayScriptEl = null,
      minutes = 5;
    const relay = () => {
      relayScriptEl.src = `//login.alibaba.com/xlogin/relay.htm?_=${Date.now()}`;
    };
    relayScriptEl = document.createElement("script");
    relayScriptEl.type = "text/javascript";
    document.head.appendChild(relayScriptEl);
    setInterval(relay, minutes * 60 * 1000);
  }

  /**
   * 打开某个联系人的会话
   * @param {*} activeLoginIdEncrypt
   */
  selectContact(encryptId) {
    const { webliteConfig = {} } = this.state;
    const {
      attrs = {},
      productId = "",
      activeLoginIdEncrypt = "",
    } = webliteConfig;
    let { sceneData, action, source, bizId = "", ...others } = attrs;

    utils.goldlog(
      `weblite_selectContact&action=${action || ""}&source=${source || ""}`
    );

    // 通知list子应用，打开对应的联系人
    EventBus.publish("im-weblite-list:selectContact", {
      productId,
      activeLoginIdEncrypt: encryptId || activeLoginIdEncrypt,
      sceneData, // 目前只有信保订单完成页面使用, 后续不建议用这个
      action, // 唤起动作
      source, // 页面来源
      sourceId: bizId, // 页面来源对应的场景id, 比如产品id, 短视频id
      others,
    });
  }

  // weblite中询盘表单
  showInquiryForm = (url) => {
    utils.goldlog("weblite_showInquiryForm");
    this._inquiry_ifm.src = url;
    this._inquiry_ifm.onload = () => {
      this._inquiry.classList.add("visible");
    };
  };

  // 关闭询盘表单
  closeInquiry = () => {
    utils.goldlog("weblite_closeInquiryForm");
    this._inquiry.classList.remove("visible");
    EventBus.publish("im-weblite-chat:closeInquiry");
  };

  // weblite中询盘表单成功页
  showInquirySucceed = (url) => {
    utils.goldlog("weblite_showInquirySucceed");
    this.closeInquiry(); // 关闭询盘表单
    this._inquiry_succeed_ifm.src = url;
    this._inquirySucceed.classList.add("visible");
    this.handleWindowResize({ type: "show" }); // 窗体最大化
  };

  // 关闭询盘表单成功页
  closeInquirySucceed = () => {
    utils.goldlog("weblite_closeInquirySucceed");
    this._inquirySucceed.classList.remove("visible");
    this.handleWindowResize({ type: "hide" }); // 窗体最大化
  };

  /**
   * 通知alitalk改变iframe尺寸,postMessage:CHANGE_SIZE
   */
  notifyIframe() {
    // 音视频展示的时候优先级最高, 窗口最大化
    if (this.meetingShow) {
      return false;
    }
    let width, height;
    if (this.chatStatus === "maxchat") {
      width = CHAT_EXPAND_WIDTH;
      height = CHAT_EXPAND_HEIGHT;
    } else if (this.chatStatus === "closechat") {
      width = LIST_WIDTH_MAP[this.listStatus];
      height = LIST_HEIGHT_MAP[this.listStatus];
    }
    // 不能使用top, 因为OP自身可能是通过iframe被嵌入的, 比如cnfm场景, 因此使用parent
    window.parent.postMessage(
      JSON.stringify({ type: "CHANGE_SIZE", width: width, height: height }),
      "*"
    );
  }

  render() {
    const landingPageCls = classNames({
      "landing-page": true,
    });
    const chatCls = classNames({
      "icbu-weblite-chat": true,
    });
    // list的宽度必须动态设置, 否则跟随iframe宽度100%会有问题
    return (
      <div className="icbu-weblite" id="icbu-weblite">
        <div
          id="icbu-weblite-list"
          className="icbu-weblite-list"
          style={{
            width: this.props.isPWA
              ? `${LIST_WIDTH_MAP["expand"]}px`
              : `${LIST_WIDTH_MAP["fold"]}px`,
          }}
          ref={(list) => (this._list = list)}
        ></div>
        <div
          id="icbu-weblite-chat"
          className={chatCls}
          ref={(chat) => (this._chat = chat)}
        ></div>
        {this.props.isPWA && (
          <div
            className={landingPageCls}
            ref={(landing) => (this._landing = landing)}
          >
            <LandingPage updateChrome={this.props.updateChrome} />
          </div>
        )}
        {this.props.isPWA &&
          !this.props.isMigrate &&
          !this.props.updateChrome && <PWAInstall version="supplier" />}

        {/* 询盘表单进沟通 */}
        <div className="icbu-inquiry" ref={(ele) => (this._inquiry = ele)}>
          <div className="inquiry-title">
            <h2>{I18N.get("inquiryTitle") || "Send Inquiry"}</h2>
            <div className="icon-close" onClick={this.closeInquiry}>
              <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                  <path d="M0 0h20v20H0z" />
                  <path
                    d="M1.894 1.012L.505 2.394l7.726 7.762-7.726 7.761L1.894 19.3l7.72-7.755 7.72 7.755 1.388-1.383-7.726-7.76 7.726-7.763-1.389-1.382-7.72 7.754-7.72-7.754z"
                    fill="#999"
                    fillRule="nonzero"
                  />
                </g>
              </svg>
            </div>
          </div>
          <iframe
            className="inquiry-iframe"
            ref={(ele) => (this._inquiry_ifm = ele)}
            width="100%"
          />
        </div>

        <div
          className="icbu-inquiry-succeed"
          ref={(ele) => (this._inquirySucceed = ele)}
        >
          <div className="inquiry-content">
            <div className="inquiry-title">
              <h2>
                {I18N.get("inquirySucceedTitle") || "More recommended services"}
              </h2>
              <div className="icon-close" onClick={this.closeInquirySucceed}>
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                  <g fill="none" fillRule="evenodd">
                    <path d="M0 0h20v20H0z" />
                    <path
                      d="M1.894 1.012L.505 2.394l7.726 7.762-7.726 7.761L1.894 19.3l7.72-7.755 7.72 7.755 1.388-1.383-7.726-7.76 7.726-7.763-1.389-1.382-7.72 7.754-7.72-7.754z"
                      fill="#999"
                      fillRule="nonzero"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <iframe
              className="inquiry-iframe"
              ref={(ele) => (this._inquiry_succeed_ifm = ele)}
              width="100%"
            />
          </div>
        </div>
      </div>
    );
  }
}

// 注意: 即使调用多次, 后续也只是更新组件, 不会重新创建
ReactDOM.render(
  <Weblite
    isPWA={isPWA()}
    updateChrome={updateChrome()}
    isMigrate={isMigrate()}
  />,
  document.getElementById("app")
);

/* ======== 一些全局通用方法 ======== */

/**
 * 判断当前是否已经登录
 */
function isLogin() {
  var loginCookie = Utils.getCookie("xman_us_t");
  return loginCookie && loginCookie.indexOf("sign=y") !== -1;
}

/**
 * 是否为PWA
 */
function isPWA() {
  // weblitePWA是给mac版使用; webATM只使用了weblite的壳, 不会提示安装PWA, 用于升级老webatm
  return (
    location.href.indexOf("weblitePWA") != -1 ||
    location.href.indexOf("webATM") != -1
  );
}

function isMigrate() {
  return location.href.indexOf("enemberId") !== -1;
}

function needUpdateChrome() {
  const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
  const version = raw ? parseInt(raw[2], 10) : false;
  return version && version < 76;
}

/**
 * 针对PWA的一些额外处理逻辑
 */
if (isPWA()) {
  window.addEventListener("load", () => {
    initPWA();
  });
}

/**
 * 初始化PWA
 */
function initPWA() {
  const webliteData = {
    webliteConfig: {
      activeLoginIdEncrypt: "",
      productId: "",
      sceneType: "pwa",
    },
    type: "weblite:init",
    refer: location.href,
    pageId: window.dmtrack_pageid || "",
  };
  if (isMigrate()) {
    const queryDict = {},
      config = {};
    location.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
        queryDict[item.split("=")[0]] = decodeURIComponent(item.split("=")[1]);
      });
    config.activeLoginIdEncrypt = queryDict["enemberId"];
    config.productId = queryDict["pid"];
    config.sceneType = queryDict["sceneType"];
    config.lazyInit = true;
    webliteData.webliteConfig = config;
    webliteData.type = "weblite:selectContact";
  }
  // 只有weblitePWA需要提示
  if (updateChrome()) {
    const dialog = Dialog.alert({
      needWrapper: false,
      content: I18N.get("detectChrome"),
      title: I18N.get("detectChromeTitle"),
      footer: (
        <Button type="primary" onClick={() => dialog.hide()}>
          OK
        </Button>
      ),
    });
  }
  window.postMessage(
    JSON.stringify(webliteData),
    `${location.protocol}//${location.host}`
  );
}

function updateChrome() {
  return location.href.indexOf("weblitePWA") != -1 && needUpdateChrome();
}

function serialize(obj) {
  const s = [];
  /* eslint-disable no-useless-escape */
  const rbracket = /\[\]$/;
  /* eslint-enable */

  const add = function (k, v) {
    v =
      typeof v === "function"
        ? v()
        : v === null
        ? ""
        : v === undefined
        ? ""
        : v;
    s[s.length] = encodeURIComponent(k) + "=" + encodeURIComponent(v);
  };
  const buildParams = function (prefix, obj) {
    let i, len, key;

    if (prefix) {
      if (Array.isArray(obj)) {
        for (i = 0, len = obj.length; i < len; i++) {
          if (rbracket.test(prefix)) {
            add(prefix, obj[i]);
          } else {
            buildParams(
              prefix + "[" + (typeof obj[i] === "object" ? i : "") + "]",
              obj[i]
            );
          }
        }
      } else if (obj && String(obj) === "[object Object]") {
        for (key in obj) {
          buildParams(prefix + "[" + key + "]", obj[key]);
        }
      } else {
        add(prefix, obj);
      }
    } else {
      if (obj && typeof obj === "object") {
        for (key in obj) {
          buildParams(key, obj[key]);
        }
      }
    }
    return s;
  };

  return buildParams("", obj).join("&");
}

export default Weblite;
